<template>
	<div :class="containerClass">
		<div v-if="!hidePrevNext" :class="prevClass">
			<button :class="[prevLinkClass, firstPageSelected() ? disabledClass : '']" :tabindex="firstPageSelected() ? -1 : 0" @click="prevPage()" @keyup.enter="prevPage()">
				<i class="fal fa-angle-left" />
			</button>
		</div>
		<div :class="pagesClass">
			<span>{{ pageText }}</span>
			<select v-model="selected" :class="pagesSelectClass" @change="changePage($event)">
				<option v-for="page in pages" :key="page.content" :value="page.content">
					{{ page.content }}
				</option>
			</select>
			<span>{{ fromText }} {{ pageCount }}</span>
		</div>
		<div v-if="!hidePrevNext" :class="nextClass">
			<button :class="[nextLinkClass, lastPageSelected() ? disabledClass : '']" :tabindex="lastPageSelected() ? -1 : 0" @click="nextPage()" @keyup.enter="nextPage()">
				<i class="fal fa-angle-right" />
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Number,
			required: true
		},
		pageCount: {
			type: Number,
			required: true
		},
		// eslint-disable-next-line vue/require-default-prop
		forcePage: {
			type: Number
		},
		clickHandler: {
			type: Function,
			default: () => {}
		},
		pageText: {
			type: String,
			required: true
		},
		fromText: {
			type: String,
			required: true
		},
		containerClass: {
			type: String,
			default: 'c c-pagination'
		},
		pagesClass: {
			type: String,
			default: 'c-pagination__body'
		},
		pagesSelectClass: {
			type: String,
			default: 'c-pagination__pages'
		},
		prevClass: {
			type: String,
			default: 'c-pagination__previous'
		},
		prevLinkClass: {
			type: String,
			default: 'c-pagination__button'
		},
		nextClass: {
			type: String,
			default: 'c-pagination__next'
		},
		nextLinkClass: {
			type: String,
			default: 'c-pagination__button'
		},
		disabledClass: {
			type: String,
			default: 'c-pagination__button--disabled'
		},
		hidePrevNext: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			innerValue: 1
		};
	},
	computed: {
		selected: {
			get() {
				return this.value || this.innerValue;
			},
			set(newValue) {
				this.innerValue = newValue;
			}
		},
		pages() {
			const items = {};
			if (this.pageCount) {
				for (let index = 0; index < this.pageCount; index++) {
					const page = {
						index,
						content: index + 1,
						selected: index === this.selected - 1
					};
					items[index] = page;
				}
			}

			return items;
		}
	},
	beforeUpdate() {
		if (this.forcePage === undefined) return;
		if (this.forcePage !== this.selected) {
			this.selected = this.forcePage;
		}
	},
	methods: {
		handlePageSelected(selected) {
			if (this.selected === selected) return;

			this.innerValue = selected;
			// this.$store.$router.push({
			//   query: { ...this.$nuxt._route.query, page: selected }
			// });
			// this.$emit('input', selected);
			this.clickHandler(selected);
		},
		changePage(event) {
			const page = Number(event.target.value);
			this.handlePageSelected(page);
		},
		prevPage() {
			if (this.selected <= 1) return;
			this.handlePageSelected(this.selected - 1);
		},
		nextPage() {
			if (this.selected >= this.pageCount) return;
			this.handlePageSelected(this.selected + 1);
		},
		firstPageSelected() {
			return this.selected === 1;
		},
		lastPageSelected() {
			return this.selected === this.pageCount || this.pageCount === 0;
		}
	}
};
</script>
